// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function defaultValue_set_city_selected(_city_selected, _city_label) {
  
}

var defaultValue = {
  city_selected: undefined,
  selected_city_label: undefined,
  set_city_selected: defaultValue_set_city_selected,
  category: "Home",
  query_params: ""
};

var context = React.createContext(defaultValue);

function useCitySelectedContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useCitySelectedContext ,
}
/* context Not a pure module */
